import { Box, Button, Stack, Typography } from '@mui/material'

import { ErrorLoggedOutImage } from './ErrorLoggedOutImage'

import { useActions } from './useActions'
import { useTexts } from './useTexts'

export function LoggedOut() {
  const texts = useTexts()
  const actions = useActions()

  return (
    <>
      <Stack direction="column" spacing={3} textAlign="center" alignItems="center">
        <Box>
          <ErrorLoggedOutImage />
        </Box>
        <Stack direction="column" spacing={1}>
          <Typography variant="h6">{texts.title}</Typography>
          <Typography variant="body2">{texts.description}</Typography>
        </Stack>
        <Stack direction="row">
          <Button variant="contained" onClick={actions.onNavigateToLogin}>
            {texts.primaryAction}
          </Button>
        </Stack>
      </Stack>
    </>
  )
}
